<template>
  <v-container fluid class="job-descriptions">
    <v-row justify="space-between">
      <v-col cols="7">
        <h2 class="mb-4">Job Board</h2>
        <p>
          <span class="color-red">Thank you</span>
          <strong>
            for participating in our R&D efforts to make HRNG stronger</strong
          >
          and helping develop you into the best candidate you can be. None of
          the actions we're taking in this project will put you in front of real
          recruiters, and should something change we'll be sure to reach out to
          you. Good luck! From your biggest fans, The HRNG Team
        </p>
      </v-col>
      <v-col>
        <!-- <div class="how-to-use"> -->
        <v-alert dense outlined colored-border color="red" class="rounded-lg">
          How to Use HRNG:
          <ol>
            <li>Find the job you'd like</li>
            <li>Read the description and prepare</li>
            <li>Record yourself giving a 60-second pitch for the role</li>
            <li>Submit your video and recent resume</li>
            <li>Receieve feedback, and if you want, try again!</li>
          </ol>
          Let's get started!
        </v-alert>
        <!-- </div> -->
      </v-col>
    </v-row>
    <v-row>
      <v-card class="jobs" v-if="jobPost">
        <v-tabs vertical>
          <v-tab v-for="item in openJobPosts" :key="item.id">
            <h3>{{ item.position }}</h3>
            <ul>
              <li>{{ item.company.name }}</li>
              <li>{{ item.address }}</li>
              <li>{{ item.experienceLevel }}</li>
              <li>{{ item.salary }}</li>
            </ul>
          </v-tab>

          <v-tab-item v-for="item in openJobPosts" :key="item.id">
            <v-card flat color="#f5f5f5">
              <v-card-text class="body-2">
                <div
                  v-if="hasApplied(item)"
                  class="text-center font-weight-bold color-red text-h5 mb-4"
                >
                  You have already applied for this position on
                  {{ hasApplied(item) }}
                </div>

                <div v-html="item.body"></div>

                <Apply
                  v-if="!hasApplied(item)"
                  mobileButtonText="Apply"
                  buttonText="Apply"
                  color="#FC4A46"
                  dark
                  :candidateId="getUserData.id"
                  :candidateFirstName="getUserData.firstName"
                  :candidateSurname="getUserData.surname"
                  :jobPostId="item.id"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import marked from 'marked';
import { authComputed } from '@/store/helpers';

import Apply from '@/components/Apply';
import { format } from 'date-fns';

export default {
  components: { Apply },
  computed: {
    ...mapGetters(['jobPost', 'loading']),
    ...authComputed,
    openJobPosts() {
      return this.jobPost.filter((job) => job.status !== 'complete');
    },
  },
  methods: {
    compiledMarkdown: function (input) {
      return marked(input, { sanitize: true });
    },
    hasApplied: function (jobPost) {
      const applied = jobPost.applicants.filter(
        (e) => e.user === this.getUserData.id
      );

      if (applied.length) {
        return format(new Date(applied[0].dateApplied), 'MMMM d, yyyy');
      }
    },
  },
  filters: {
    marked: marked,
  },
  mounted() {
    this.$store.dispatch('FETCH_ALLPOSTS');
  },
};
</script>

<style lang="scss">
.job-descriptions {
  .color-red {
    color: #f44336;
  }
  ol {
    padding-left: 15px;
  }
  .v-alert.theme--light.v-sheet {
    border-color: #0274b3 !important;
  }
  .how-to-use {
    border: 1px solid #0274b3;
    border-radius: 10px;
    padding: 10px;
  }
}

.jobs {
  .v-tabs-bar__content {
    overflow-y: auto;
    height: 100vh;
  }
  .v-tab--active {
    background: #e5f0f6;
  }
  .v-tab {
    display: block;
    text-align: left;
    text-transform: none;
    padding-bottom: 10px;
    padding-top: 10px;
    height: auto !important;

    ul {
      list-style-type: none;
      padding-left: 0;
    }
  }
}
</style>
